module.exports = __webpack_public_path__ + "img/avatar-symbol.68f0f4e8.svg";